import { render, staticRenderFns } from "./BookingProfile.vue?vue&type=template&id=47a72b84"
import script from "./BookingProfile.vue?vue&type=script&lang=js"
export * from "./BookingProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports